export default __webpack_public_path__ + "static/media/icon-checkmark.e405dedd.svg";